import { useEffect, useState } from '@wordpress/element';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Loading } from './Loading';
import './style.scss';
import parse from 'html-react-parser';
import { makeRestCall } from './service/makeRestCall';

// const baseURL = 'https://api.campuspiemonte.com/public/';
const baseURL = 'https://apicampus.betacomservices.com/public/';


export function APIBlock({urlSelected, languageSelected }) {
  const [data, setData] = useState();
  const [openAccordions, setOpenAccordions] = useState({});
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');

  const toggleAccordion = (id) => {
    setOpenAccordions(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  

  useEffect(() => {

    async function fetchData() {
        const { filteredData, uniqueCities } = await makeRestCall(baseURL, urlSelected, languageSelected);
        setData(filteredData);
        setCities(uniqueCities);
    }
    fetchData();

  }, [urlSelected,languageSelected]);

  const filteredData = selectedCity
    ? data?.filter(item => item.comune == selectedCity)
    : data;


  return (
  <>
    
    <div id='APIBridgeConnect'>
      
      <div className="filter-buttons">
        <button
          className={`filter-button ${selectedCity === '' ? 'active' : ''}`}
          onClick={() => setSelectedCity('')}
        >
          Tutte le città
        </button>

        {cities.map(city => (
          <button
            key={city}
            className={`filter-button ${selectedCity == city ? 'active' : ''}`}
            onClick={() => setSelectedCity(city)}
            href={`#${city}`}
          >
            {city}
          </button>
        ))}
      </div>

      {filteredData ? (
        filteredData.map((item) => {
          const isOpen = openAccordions[item.id] || false;
          
          return (
            
            <div key={item.id} className='accordion'> 
              <h5 className='accordion-button' onClick={() => {toggleAccordion(item.id)} } name={item.alt}>
                {item.nome} 
                {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}		
              </h5>

              {isOpen && (
                <>
                  <div className='item_info'>
                    {item.struttura && <p>{item.struttura}</p>}
                    {item.indirizzo &&<p><strong>Indirizzo:</strong> <br/>{parse(`${item.indirizzo}`)}</p>}
                    {item.telefono && <p><strong>Telefono:</strong> {item.telefono}</p>}
                    {item.email && <p><strong>Email:</strong> {item.email}</p>}
                    {item.orari && <p><strong>Orari:</strong> <br/>{parse(`${item.orari}`)}</p>}
                    {item.info && <p><strong>Attività sportive e ricreative:</strong> {item.info}</p>}
                  </div>
                  <div className='table'>
                    {(item.come_raggiungerla || item.url_maps) && (
                      <div className='table_location subtable'>
                        <h6>Come arrivarci</h6>
                        {item.come_raggiungerla && <p>{parse(`${item.come_raggiungerla}`)}</p>}
                        {item.url_maps && <a href={item.url_maps} target='_blank' rel="noopener noreferrer">Visualizza sulla mappa</a>}
                      </div>
                    )}
                    {(item.capienza || item.come_accedere || item.gestione || item.destinatari || item.notizie || item.condizioni_servizio || item.allegati || item.link_prestito_testi) && (
                      <div className='table_info subtable'>
                        <h6>Informazioni utili</h6>
                        {item.capienza && <p><strong>Capienza:</strong> {item.capienza}</p>}
                        {item.come_accedere && <p><strong>Come accedere:</strong> {parse(`${item.come_accedere}`)}</p>}
                        {item.gestione && <p><strong>Gestione:</strong> {item.gestione}</p>}
                        {item.destinatari && <p><strong>Destinatari:</strong> {item.destinatari}</p>}
                        {item.notizie && <p><strong>Notizie:</strong> {item.notizie}</p>}
                        {item.condizioni_servizio && <p><strong>Condizioni di servizio: </strong> {item.condizioni_servizio}</p>}
                        {item.allegati && <a href={item.allegati} target='_blank' rel="noopener noreferrer">Guarda l'allegato</a>}
                        {item.link_prestito_testi && <a href={item.link_prestito_testi} target='_blank' rel="noopener noreferrer">Prestito testi</a>}    
                      </div>
                    )}
                    {(item.link_come_accedere) && (
                      <div className='table_access_botton subtable'>
                        <h6>Come accedere</h6>
                        <h4>Prenotazione tramite Campus Piemonte ID Studyroom</h4>
                        <p>{item.come_accedere}</p>
                        <a href={item.link_come_accedere} target='_blank' rel="noopener noreferrer">{item.bottone_come_accedere}</a> 
                        </div>
                    )}
                    {(item.camere || item.camere_dotazioni) && (
                      <div className='table_info subtable'>
                        <h6>Informazioni sulle camere</h6>
                        
                        {item.camere && <p><strong>Camera:</strong> <br/> {parse(`${item.camere}`)}</p>}
                        {item.camere_dotazioni && <p><strong>Dotazioni camere:</strong> <br/>{parse(`${item.camere_dotazioni}`)}</p>}
                      </div>
                    )}
                    {(item.servizi || item.servizi_correlati || item.link_oggetti_smarriti) && (
                    <div className='table_menu subtable'>
                      <h6>Servizi</h6>
                      {item.servizi && <p>{parse(`${item.servizi}`)}</p>}
                      {item.servizi_correlati && <p><strong>Servizi Correlati:</strong> {parse(`${item.servizi_correlati}`)}</p>}
                      {item.link_oggetti_smarriti && <a href={item.link_oggetti_smarriti} target='_blank' rel="noopener noreferrer">Oggetti smarriti</a>}    
                      </div>)
                    }
                    {(item.menu || item.menu_cena) && (
                      <div className='table_menu subtable'>
                        <h6>Menù</h6>
                        <p>Visualizza il menù</p>
                        {item.menu && <a href={item.menu}>Menù</a>}
                        {item.menu_cena && <a href={item.menu_cena}>Menù Cena</a>}
                      </div>
                    )}
                    {(item.tariffe_url || item.tariffe) && (
                      <div className='table_meal subtable'>
                        <h6>Tariffe Pasti</h6>
                        {item.tariffe_url && <a href={item.tariffe_url} target='_blank' rel="noopener noreferrer">Consulta qui le formule e tariffe per i pasti</a>}
                        {item.tariffe && <p>{parse(`${item.tariffe}`)}</p>}
                        </div>
                    )}
                    {item.tariffe_eventi &&
                      <div className='table_events subtable'>
                        <h6>Tariffe Eventi</h6>
                        <p>{parse(`${item.tariffe_eventi}`)}</p>
                      </div>
                    }
                  </div>
                </>
              )}
            </div>
          );
        })
      ) : (
        <Loading />
      )}
    </div>
  </>
  );
}